'use client'

import { usePathname } from 'next/navigation'
import { useStytchMember } from '@stytch/nextjs/b2b'
import { CLIENT_PATHS, CLIENT_PUBLIC_LEGAL_PATHS } from '@/utilities/paths'

export type ClientNavMode = 'none' | 'post-auth' | 'pre-auth'

export function isClientAuthPath(pathname: string): boolean {
  return /^\/(login|logout|authenticate)(?:$|\/)/.test(pathname) || pathname === CLIENT_PATHS.login
}

export function isClientPreAuthHeaderPath(pathname: string): boolean {
  return CLIENT_PUBLIC_LEGAL_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  )
}

/** Stytch auth routes omit the layout footer; consent and post-auth pages keep it. */
export function shouldShowClientPortalFooter(pathname: string): boolean {
  return !isClientAuthPath(pathname)
}

export function getClientNavMode(
  pathname: string,
  isInitialized: boolean,
  hasMember: boolean,
): ClientNavMode {
  if (isClientAuthPath(pathname)) return 'pre-auth'
  if (!isInitialized) {
    if (isClientPreAuthHeaderPath(pathname)) return 'pre-auth'
    return 'none'
  }
  if (hasMember) return 'post-auth'
  if (isClientPreAuthHeaderPath(pathname)) return 'pre-auth'
  return 'none'
}

export function useClientNavMode(): ClientNavMode {
  const pathname = usePathname() || ''
  const { member, isInitialized } = useStytchMember()
  return getClientNavMode(pathname, isInitialized, Boolean(member))
}
